import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import Music from './pages/Music';
import Videos from './pages/Videos';
import Merch from './pages/Merch';
import About from './pages/About';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import ProtectedRoute from './admin/ProtectedRoute';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/music" element={<Music />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/merch" element={<Merch />} />
        <Route path="/about" element={<About />} />

        <Route path="/2gslikegucciadmin/login" element={<AdminLogin />} />
        <Route
          path="/2gslikegucciadmin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

// import React from 'react';
// import { Routes, Route } from 'react-router-dom';
// import { AuthProvider } from './context/AuthContext';
// import Home from './pages/Home';
// import Music from './pages/Music';
// import Videos from './pages/Videos';
// import Merch from './pages/Merch';
// import About from './pages/About';
// import AdminLogin from './admin/AdminLogin';
// import AdminDashboard from './admin/AdminDashboard';
// import ProtectedRoute from './admin/ProtectedRoute';

// export default function App() {
//   return (
//     <AuthProvider>
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/music" element={<Music />} />
//         <Route path="/videos" element={<Videos />} />
//         <Route path="/merch" element={<Merch />} />
//         <Route path="/about" element={<About />} />

//         <Route path="/admin/login" element={<AdminLogin />} />
//         <Route
//           path="/admin"
//           element={
//             <ProtectedRoute>
//               <AdminDashboard />
//             </ProtectedRoute>
//           }
//         />
//       </Routes>
//     </AuthProvider>
//   );
// }
